"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndexName = getIndexName;
exports.toElasticQuery = toElasticQuery;
exports.mapSearchableAttributes = mapSearchableAttributes;
exports.mapNumericFilter = mapNumericFilter;
exports.mapTimestampFilter = mapTimestampFilter;
exports.mapDateFilter = mapDateFilter;
const date_fns_1 = require("date-fns");
const schema_1 = require("../schema");
const extract_appropriate_types_1 = require("../utils/extract-appropriate-types");
/**
 * Returns the index name for a given schema and environment. The master version of this is in @wayste/search-adapters.
 * The reason it is replicated here is to avoid a circular dependency.
 */
function getIndexName(schema, environment) {
    return `${schema.name}-${environment}`;
}
function toElasticQuery(query, { application, environment, customerID, haulerID, multiMatchType }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const typeRestriction = query.type;
    if (application === 'wayste' && !haulerID) {
        throw new Error('Hauler ID must be provided for wayste search');
    }
    if (application === 'customer-portal' && !customerID) {
        throw new Error('Customer ID must be provided for customer portal search');
    }
    if (application === 'customer-portal' && query.type === 'sourgum-receivable') {
        query.filters = finalizeWQLFilters(query.filters, application, query.type);
    }
    if (Array.isArray((_a = query.query) === null || _a === void 0 ? void 0 : _a.restrictToFields) && ((_b = query.query) === null || _b === void 0 ? void 0 : _b.restrictToFields.length) === 0) {
        // remove it
        delete query.query.restrictToFields;
    }
    if (typeRestriction) {
        const schema = schema_1.SearchSchema[typeRestriction];
        const elasticQuery = {
            index: getIndexName(schema, environment),
            query: {
                bool: {
                    must: [],
                    filter: [],
                },
            },
        };
        if ((_c = query.query) === null || _c === void 0 ? void 0 : _c.query) {
            const bool = {
                must: [
                    {
                        multi_match: {
                            query: ((_d = query.query) === null || _d === void 0 ? void 0 : _d.query) || '',
                            fields: mapSearchableAttributes(((_e = query.query) === null || _e === void 0 ? void 0 : _e.restrictToFields) ||
                                [...schema.searchableAttributes]
                                    .filter((attribute) => { var _a; return attribute.searchableByDefault && !((_a = attribute.disabledOn) === null || _a === void 0 ? void 0 : _a.includes(application)); })
                                    .map((attribute) => attribute.field)),
                            type: multiMatchType !== null && multiMatchType !== void 0 ? multiMatchType : 'bool_prefix',
                        },
                    },
                ],
                filter: [],
            };
            elasticQuery.query = { bool };
        }
        if (query.filters && query.filters.length > 0) {
            const filters = query.filters
                // @ts-expect-error -- ts is right this is impossible, but we need to filter out nulls because frontend
                .filter((filter) => filter.value !== null || filter.value !== undefined)
                .map((filter) => {
                switch (filter.type) {
                    case 'STRING':
                        if (filter.operator === 'IS_NOT_IN' || filter.operator === 'IS_NOT_EQUAL_TO') {
                            return {
                                bool: {
                                    must_not: {
                                        terms: {
                                            [`${filter.field}.keyword`]: Array.isArray(filter.value)
                                                ? filter.value
                                                : [filter.value],
                                        },
                                    },
                                },
                            };
                        }
                        return {
                            terms: {
                                [`${filter.field}.keyword`]: Array.isArray(filter.value)
                                    ? filter.value
                                    : [filter.value],
                            },
                        };
                    case 'NUMBER':
                        return mapNumericFilter(filter);
                    case 'BOOLEAN':
                        return {
                            term: {
                                [filter.field]: filter.value,
                            },
                        };
                    case 'TIMESTAMP':
                        return mapTimestampFilter(filter);
                    case 'DATE':
                        return mapDateFilter(filter);
                }
            })
                .filter((filter) => filter === null || filter === undefined || Object.keys(filter).length > 0);
            elasticQuery.query.bool.filter = filters;
            // query.filters.forEach((filter) => {
            //   if ((filter.type = 'STRING')) {
            //     const term: estypes.QueryDslQueryContainer['term'] = {
            //       [filter.field]: Array.isArray(filter.value) ? (filter.value as string[]) : [filter.value as string],
            //     };
            //     if (elasticQuery.query?.bool && Array.isArray(elasticQuery.query.bool.filter)) {
            //       elasticQuery.query.bool.filter = [...(elasticQuery.query.bool.filter || []), term];
            //     } else if (elasticQuery.query) {
            //       elasticQuery.query = {
            //         bool: {
            //           filter: [term],
            //         },
            //       };
            //     }
            //   }
            // });
        }
        if (query.sort) {
            elasticQuery.sort = [
                {
                    [query.sort.field]: {
                        order: mapSortDirectionToElasticsearchDirection(query.sort.direction),
                    },
                },
            ];
            if (query.sort.needsDeterministicSortingAdded ||
                ((_f = [...schema.filterableAttributes].find((attribute) => { var _a; return attribute.field === ((_a = query === null || query === void 0 ? void 0 : query.sort) === null || _a === void 0 ? void 0 : _a.field); })) === null || _f === void 0 ? void 0 : _f.needsDeterministicSorting)) {
                elasticQuery.sort.push('_doc');
            }
        }
        if (application === 'wayste' && Array.isArray((_h = (_g = elasticQuery.query) === null || _g === void 0 ? void 0 : _g.bool) === null || _h === void 0 ? void 0 : _h.filter)) {
            elasticQuery.query.bool.filter.push({
                term: {
                    'haulerID.keyword': haulerID,
                },
            });
        }
        else if (application === 'wayste') {
            throw new Error('Hauler ID must be provided for wayste search');
        }
        if (application === 'customer-portal' && Array.isArray((_k = (_j = elasticQuery.query) === null || _j === void 0 ? void 0 : _j.bool) === null || _k === void 0 ? void 0 : _k.filter)) {
            elasticQuery.query.bool.filter.push({
                bool: {
                    should: [
                        {
                            term: {
                                'allianceCustomerID.keyword': customerID,
                            },
                        },
                        {
                            term: {
                                'customerID.keyword': customerID,
                            },
                        },
                    ],
                },
            });
        }
        else if (application === 'customer-portal') {
            throw new Error('Customer ID must be provided for customer portal search');
        }
        return elasticQuery;
    }
    // If no type restriction is given, we search all types and there can be no filters
    const allowedSchemas = (0, extract_appropriate_types_1.extractAllowedSchemas)(application);
    const allSearchableAttributes = allowedSchemas.reduce((acc, schema) => {
        return [...acc, ...schema.searchableAttributes];
    }, []);
    const elasticQuery = {
        index: allowedSchemas.map((schema) => getIndexName(schema, environment)),
        size: 0,
        query: {
            bool: {
                must: [
                    {
                        multi_match: {
                            query: ((_l = query.query) === null || _l === void 0 ? void 0 : _l.query) || '',
                            fields: mapSearchableAttributes(((_m = query.query) === null || _m === void 0 ? void 0 : _m.restrictToFields) ||
                                [...allSearchableAttributes]
                                    .filter((attribute) => { var _a; return attribute.searchableByDefault && !((_a = attribute.disabledOn) === null || _a === void 0 ? void 0 : _a.includes(application)); })
                                    .map((attribute) => attribute.field)),
                            type: multiMatchType !== null && multiMatchType !== void 0 ? multiMatchType : 'bool_prefix',
                        },
                    },
                ],
                filter: [],
            },
        },
        aggs: {
            index_agg: {
                terms: {
                    field: '_index',
                    size: 20,
                },
                aggs: {
                    hits_per_index: {
                        top_hits: {
                            size: 3,
                        },
                    },
                },
            },
        },
    };
    if (application === 'wayste' && Array.isArray((_p = (_o = elasticQuery.query) === null || _o === void 0 ? void 0 : _o.bool) === null || _p === void 0 ? void 0 : _p.filter)) {
        elasticQuery.query.bool.filter.push({
            term: {
                'haulerID.keyword': haulerID,
            },
        });
    }
    else if (application === 'wayste') {
        throw new Error('Hauler ID must be provided for wayste search');
    }
    if (application === 'customer-portal' && Array.isArray((_r = (_q = elasticQuery.query) === null || _q === void 0 ? void 0 : _q.bool) === null || _r === void 0 ? void 0 : _r.filter)) {
        elasticQuery.query.bool.filter.push({
            bool: {
                should: [
                    {
                        term: {
                            'allianceCustomerID.keyword': customerID,
                        },
                    },
                    {
                        term: {
                            'customerID.keyword': customerID,
                        },
                    },
                ],
            },
        });
        if (!query.type) {
            elasticQuery.query.bool.filter.push({
                term: {
                    'invoiceDetails.void': false,
                },
            }, {
                bool: {
                    must_not: {
                        terms: {
                            'invoiceDetails.status.keyword': ['DRAFT'],
                        },
                    },
                },
            });
        }
    }
    else if (application === 'customer-portal') {
        throw new Error('Customer ID must be provided for customer portal search');
    }
    return elasticQuery;
}
function mapSearchableAttributes(attributes) {
    return attributes.reduce((acc, attribute) => {
        acc.push(attribute);
        acc.push(`${attribute}._2gram`);
        acc.push(`${attribute}._3gram`);
        return acc;
    }, []);
}
function mapNumericFilter(filter) {
    if (filter.type !== 'NUMBER' && typeof filter.value !== 'number') {
        throw new Error(`Filter type ${filter.type} is not a number, cannot map to number`);
    }
    switch (filter.operator) {
        case 'IS_EQUAL_TO':
            return {
                term: {
                    [filter.field]: filter.value,
                },
            };
        case 'IS_NOT_EQUAL_TO':
            return {
                bool: {
                    must_not: {
                        term: {
                            [filter.field]: filter.value,
                        },
                    },
                },
            };
        case 'IS_GREATER_THAN':
            return {
                range: {
                    [filter.field]: {
                        gt: filter.value,
                    },
                },
            };
        case 'IS_GREATER_THAN_OR_EQUAL_TO':
            return {
                range: {
                    [filter.field]: {
                        gte: filter.value,
                    },
                },
            };
        case 'IS_LESS_THAN':
            return {
                range: {
                    [filter.field]: {
                        lt: filter.value,
                    },
                },
            };
        case 'IS_LESS_THAN_OR_EQUAL_TO':
            return {
                range: {
                    [filter.field]: {
                        lte: filter.value,
                    },
                },
            };
        case 'IS_BETWEEN':
        default:
            throw new Error(`Operator ${filter.operator} not implemented`);
    }
}
function mapTimestampFilter(filter) {
    if (filter.type !== 'DATE' && filter.type !== 'TIMESTAMP') {
        throw new Error(`Filter type ${filter.type} is not a date or timestamp, cannot map to date`);
    }
    // assert that the value is an object
    if (typeof filter.value !== 'object') {
        throw new Error(`Filter value is not an object, cannot map to date`);
    }
    switch (filter.operator) {
        case 'IS_IN_THE_LAST':
            return {
                range: {
                    [filter.field]: {
                        gte: `now-${filter.value.value}${mapTimeUnitToElasticsearchDateMath(filter.value.unit)}/d`,
                        lte: 'now',
                    },
                },
            };
        case 'IS_EQUAL_TO':
            return {
                range: {
                    [filter.field]: {
                        gte: (0, date_fns_1.startOfDay)(filter.value.eq).toISOString(),
                        lte: (0, date_fns_1.endOfDay)(filter.value.eq).toISOString(),
                    },
                },
            };
        case 'IS_BETWEEN':
            return {
                range: {
                    [filter.field]: {
                        gte: (0, date_fns_1.startOfDay)(filter.value.gt).toISOString(),
                        lte: (0, date_fns_1.endOfDay)(filter.value.lt).toISOString(),
                    },
                },
            };
        case 'IS_AFTER':
            return {
                range: {
                    [filter.field]: {
                        gt: (0, date_fns_1.startOfDay)(filter.value.gt).toISOString(),
                    },
                },
            };
        case 'IS_ON_OR_AFTER':
            return {
                range: {
                    [filter.field]: {
                        gte: (0, date_fns_1.startOfDay)(filter.value.gte).toISOString(),
                    },
                },
            };
        case 'IS_BEFORE':
            return {
                range: {
                    [filter.field]: {
                        lt: (0, date_fns_1.endOfDay)(filter.value.lt).toISOString(),
                    },
                },
            };
        case 'IS_ON_OR_BEFORE':
            return {
                range: {
                    [filter.field]: {
                        lte: (0, date_fns_1.endOfDay)(filter.value.lte).toISOString(),
                    },
                },
            };
        default:
            // @ts-expect-error -- ts is right this SHOULD be impossible if it's not you've added a new operator
            throw new Error(`Operator ${filter.operator} not implemented`);
    }
}
function mapDateFilter(filter) {
    if (filter.type !== 'DATE' && filter.type !== 'TIMESTAMP') {
        throw new Error(`Filter type ${filter.type} is not a date or timestamp, cannot map to date`);
    }
    // assert that the value is an object
    if (typeof filter.value !== 'object') {
        throw new Error(`Filter value is not an object, cannot map to date`);
    }
    if (filter.type === 'DATE') {
        switch (filter.operator) {
            case 'IS_IN_THE_LAST':
                return {
                    range: {
                        [filter.field]: {
                            gte: `now-${filter.value.value}${mapTimeUnitToElasticsearchDateMath(filter.value.unit)}/d`,
                            lte: 'now',
                        },
                    },
                };
            case 'IS_EQUAL_TO':
                return {
                    term: {
                        [filter.field]: filter.value.eq.toISOString().slice(0, 10),
                    },
                };
            case 'IS_BETWEEN':
                return {
                    range: {
                        [filter.field]: {
                            gte: (0, date_fns_1.startOfDay)(filter.value.gt).toISOString().slice(0, 10),
                            lte: (0, date_fns_1.endOfDay)(filter.value.lt).toISOString().slice(0, 10),
                        },
                    },
                };
            case 'IS_AFTER':
                return {
                    range: {
                        [filter.field]: {
                            gt: (0, date_fns_1.startOfDay)(filter.value.gt).toISOString().slice(0, 10),
                        },
                    },
                };
            case 'IS_ON_OR_AFTER':
                return {
                    range: {
                        [filter.field]: {
                            gte: (0, date_fns_1.startOfDay)(filter.value.gte).toISOString().slice(0, 10),
                        },
                    },
                };
            case 'IS_BEFORE':
                return {
                    range: {
                        [filter.field]: {
                            lt: (0, date_fns_1.endOfDay)(filter.value.lt).toISOString().slice(0, 10),
                        },
                    },
                };
            case 'IS_ON_OR_BEFORE':
                return {
                    range: {
                        [filter.field]: {
                            lte: (0, date_fns_1.endOfDay)(filter.value.lte).toISOString().slice(0, 10),
                        },
                    },
                };
            default:
                // @ts-expect-error -- ts is right this SHOULD be impossible if it's not you've added a new operator
                throw new Error(`Operator ${filter.operator} not implemented`);
        }
    }
    switch (filter.operator) {
        case 'IS_IN_THE_LAST':
            return {
                range: {
                    [filter.field]: {
                        gte: `now-${filter.value.value}${mapTimeUnitToElasticsearchDateMath(filter.value.unit)}/d`,
                        lte: 'now',
                    },
                },
            };
        case 'IS_EQUAL_TO':
            return {
                range: {
                    [filter.field]: {
                        gte: (0, date_fns_1.startOfDay)(filter.value.eq).toISOString().slice(0, 10),
                        lte: (0, date_fns_1.endOfDay)(filter.value.eq).toISOString().slice(0, 10),
                    },
                },
            };
        case 'IS_BETWEEN':
            return {
                range: {
                    [filter.field]: {
                        gte: (0, date_fns_1.startOfDay)(filter.value.gt).toISOString().slice(0, 10),
                        lte: (0, date_fns_1.endOfDay)(filter.value.lt).toISOString().slice(0, 10),
                    },
                },
            };
        case 'IS_AFTER':
            return {
                range: {
                    [filter.field]: {
                        gt: (0, date_fns_1.startOfDay)(filter.value.gt).toISOString().slice(0, 10),
                    },
                },
            };
        case 'IS_ON_OR_AFTER':
            return {
                range: {
                    [filter.field]: {
                        gte: (0, date_fns_1.startOfDay)(filter.value.gte).toISOString().slice(0, 10),
                    },
                },
            };
        case 'IS_BEFORE':
            return {
                range: {
                    [filter.field]: {
                        lt: (0, date_fns_1.endOfDay)(filter.value.lt).toISOString().slice(0, 10),
                    },
                },
            };
        case 'IS_ON_OR_BEFORE':
            return {
                range: {
                    [filter.field]: {
                        lte: (0, date_fns_1.endOfDay)(filter.value.lte).toISOString().slice(0, 10),
                    },
                },
            };
        default:
            // @ts-expect-error -- ts is right this SHOULD be impossible if it's not you've added a new operator
            throw new Error(`Operator ${filter.operator} not implemented`);
    }
}
function mapTimeUnitToElasticsearchDateMath(unit) {
    switch (unit) {
        case 'HOURS':
            return 'h';
        case 'DAYS':
            return 'd';
        case 'WEEKS':
            return 'w';
        case 'SECONDS':
            return 's';
        case 'MINUTES':
            return 'm';
        case 'MONTHS':
            return 'M';
        case 'YEARS':
            return 'y';
        default:
            throw new Error(`Invalid time unit: ${unit}`);
    }
}
function mapSortDirectionToElasticsearchDirection(direction) {
    switch (direction) {
        case 'ASC':
            return 'asc';
        case 'DESC':
            return 'desc';
        default:
            throw new Error(`Invalid sort direction: ${direction}`);
    }
}
function finalizeWQLFilters(filters, application, type) {
    if (application === 'customer-portal' && type === 'sourgum-receivable') {
        const sgReceivable = filters;
        sgReceivable.push({ field: 'invoiceDetails.void', operator: 'IS_EQUAL_TO', type: 'BOOLEAN', value: false });
        const found = sgReceivable === null || sgReceivable === void 0 ? void 0 : sgReceivable.find((item) => item.field === 'invoiceDetails.status');
        if (!found) {
            return [
                ...sgReceivable,
                { field: 'invoiceDetails.status', operator: 'IS_NOT_IN', type: 'STRING', value: ['DRAFT'] },
            ];
        }
        if (found && (found.operator === 'IS_NOT_EQUAL_TO' || found.operator === 'IS_NOT_IN')) {
            return [
                ...sgReceivable,
                {
                    ...found,
                    operator: 'IS_NOT_IN',
                    // @ts-expect-error -- found would be an array
                    value: found.operator === 'IS_NOT_EQUAL_TO' ? [found.value, 'DRAFT'] : [...found.value, 'DRAFT'],
                },
            ];
        }
    }
    return filters;
}
//# sourceMappingURL=elastic-query.js.map